import { Icon } from '@fv/client-components'
import type { Quote } from '@fv/client-types'
import type { Currency, ExchangeRateMap } from '@fv/models'

import { Price } from '@/components/shared/Price'
import { convertCurrency } from '@/hooks/useExchangeRate'

import { usePermissions } from '../auth'

type Props = {
  rate: Quote
  displayCurrency?: Currency | null
  exchangeRates?: ExchangeRateMap
  showCurrency?: boolean
}
export const RatePriceDisplay = ({
  rate,
  displayCurrency,
  exchangeRates,
  showCurrency,
}: Props) => {
  const { canViewRates } = usePermissions()

  const converted =
    displayCurrency && exchangeRates
      ? convertCurrency(
          rate.amount,
          rate.currency,
          displayCurrency,
          exchangeRates,
        )
      : { amount: rate.amount, currency: rate.currency ?? 'usd' }

  if (!canViewRates && rate.amount === 0) return null // cheapest quote

  const showCurrencyLabel =
    showCurrency || !!displayCurrency || converted.currency !== 'usd'

  return (
    <>
      {!canViewRates && (
        <Icon icon="plus" className="text-black text-sm self-center mr-1" />
      )}
      <Price
        amount={converted.amount}
        currency={showCurrencyLabel ? converted.currency : ''}
        size="lg"
      />
    </>
  )
}
